import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectParamExercisesQuestionnaireIds } from './exercise.selectors';

@Injectable({
  providedIn: 'root',
})
export class ExerciseFacade {
  private readonly store: Store = inject(Store);

  public readonly paramExercisesQuestionnaireIds: Signal<string[]> =
    this.store.selectSignal(selectParamExercisesQuestionnaireIds);
}
